"use client";
import { SetStateAction, useState } from "react";
import SinglePriceCard from "./SinglePriceCard";

const PricingToggle = ({
  isActive,
  setActiveButton,
}: {
  isActive: string;
  setActiveButton: React.Dispatch<SetStateAction<string>>;
}) => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-3 rounded-full border border-[#E6E6F5] bg-white px-4 py-0.5">
      <span
        className={`text-[14px] font-medium sm:text-[16px] ${
          isActive === "monthly" ? "text-[#202020]" : "text-[#717171]"
        }`}
      >
        Monthly
      </span>
      <button
        role="switch"
        aria-checked={isActive === "yearly"}
        onClick={() =>
          setActiveButton(isActive === "yearly" ? "monthly" : "yearly")
        }
        className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${
          isActive === "yearly" ? "bg-[#6049E7]" : "bg-[#E6E6F5]"
        }`}
      >
        <span
          className={`absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow transition-transform ${
            isActive === "yearly" ? "translate-x-5" : "translate-x-0"
          }`}
        />
      </button>
      <span
        className={`text-[14px] font-medium sm:text-[16px] ${
          isActive === "yearly" ? "text-[#202020]" : "text-[#717171]"
        }`}
      >
        Yearly
      </span>
      <span className="rounded-full bg-green-100 px-2 py-1 text-[12px] text-[#22C55E] sm:text-[14px]">
        Save -20%
      </span>
    </div>
  );
};

const pricingList = [
  {
    intro: "Starter",
    subtitle: "Ideal for personal use",
    price: null,
    buttonText: "Get Started Free",
    featureList: [
      "1 Workspaces",
      "5 Projects",
      "Unlimited Tasks",
      "Invite Up to 5 Members",
      "5 Goals",
      "5 Channels / Unlimited Chats",
      "5 Teams",
      "With Generative AI",
    ],
  },
  {
    intro: "Plus",
    subtitle: "Ideal for 2-20 users",
    price: {
      monthly: 30,
      yearly: 25,
    },
    buttonText: "Start 14-day free trial",
    featureList: [
      "5 Workspaces",
      "50 Projects",
      "Unlimited Tasks",
      "Invite Up to 20 Members",
      "20 Teams",
      "20 Goals",
      "100 Docs",
      "20 Channels / Unlimited Chats",
      "With Generative AI",
    ],
  },
  {
    intro: "Business",
    subtitle: "Ideal for 20-500 users",
    price: {
      monthly: 45,
      yearly: 35,
    },
    buttonText: "Contact Sales",
    featureList: [
      "Unlimited Workspaces",
      "Unlimited Projects",
      "Unlimited Tasks",
      "Invite Up to 500 Members",
      "Unlimited Teams",
      "Unlimited Goals",
      "Unlimited Docs",
      "Unlimited Channels / Chats",
      "With Generative AI",
    ],
  },
  {
    intro: "Enterprise",
    subtitle: "",
    price: null,
    customHeaderText: "Get a custom demo",
    buttonText: "Contact Sales",
    featureList: [
      "Team / Skills Sharing",
      "Custom Roles",
      "Resource Workload",
      "Enterprise AI",
      "Project Financials and Tracking",
      "Single Sign On (SSO)",
      "SCIM Provisioning",
      "US, EU, & APAC Data Residency",
      "Live onboarding and training",
      "Dedicated CSM",
    ],
  },
];

const PricingCardsArea = () => {
  const [packageTime, setPackageTime] = useState<string>("yearly");
  const [highlightPackage, setHighlightPackage] = useState<number | null>(3);

  return (
    <div>
      <div className="mt-[8px] xl:mt-[12px]">
        <div className="mb-6 flex flex-wrap items-center justify-center xl:mb-8">
          <PricingToggle
            isActive={packageTime}
            setActiveButton={setPackageTime}
          />
        </div>
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-4 xl:gap-4">
          {pricingList.map((item, index) => (
            <SinglePriceCard
              setHighlightPackage={setHighlightPackage}
              info={item}
              key={index}
              defaultShow={index + 1 == highlightPackage}
              packageTime={packageTime}
              packageNumber={index + 1}
              highlightPackage={highlightPackage}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingCardsArea;
